import { useState, useEffect, useRef } from 'react'
import Input from '@mui/material/Input'
import { Theme } from '../../../Theme'

export const TextEdit = props => {
  const [newValue, setNewValue] = useState(props.data || '')
  const [height] = useState(props.parent.clientHeight)
  const inputRef = useRef(null)

  useEffect(() => {
    props.updateData(newValue)
  }, [newValue])

  useEffect(() => {
    inputRef.current.firstChild.focus()
    inputRef.current.firstChild.setSelectionRange(
      inputRef.current.firstChild.value.length,
      inputRef.current.firstChild.value.length,
    )
  }, [])

  const checkForEnter = e => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      e.preventDefault()
      props.updateData(newValue)
      props.close(true)
    }
    if (e.key === 'Escape') {
      e.stopPropagation()
      e.preventDefault()
      props.updateData(props.data)
      props.close()
    }
    if (e.key === 'Tab') {
      e.stopPropagation()
      e.preventDefault()
      props.updateData(newValue)
      props.close()
    }
  }

  return (
    <Theme>
      <Input
        value={newValue}
        autoFocus={true}
        ref={inputRef}
        onKeyDown={checkForEnter}
        onChange={e => {
          setNewValue(e.target.value)
        }}
        style={{
          boxSizing: 'border-box',
          height: 'initial',
          minHeight: height,
          width: '100%',
          backgroundColor: 'white',
          position: 'relative',
          paddingLeft: 4,
          paddingRight: 4,
          border: '1px solid #25515B',
        }}
        multiline={true}
        disableUnderline={true}
      />
    </Theme>
  )
}
